<template>
  <div class="container-fluid py-4">

    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique flex-wrap">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-cash-coin fs-2 text-success"></i>
        <h2 class="fw-bold mb-0">Paiements Consultation</h2>
      </div>
      <button class="btn btn-success me-2" @click="exportCsv" v-if="$store.getters.hasPermission('TRANS_LIST_CONSULTATION_EXPORT')">
  <i class="bi bi-file-earmark-excel me-2"></i> Export Excel
</button>
      <button class="btn btn-primary" @click="imprimerPaiements" v-if="$store.getters.hasPermission('TRANS_LIST_CONSULTATION_IMPRESSION')">
        <i class="bi bi-printer me-2"></i> Imprimer
      </button>
    </div>

    <!-- Filtres -->
    <div class="card p-3 mb-4 shadow-sm rounded card-clinique">
      <div class="row g-3 align-items-end">

        <div class="col-12 col-md-3">
          <label class="form-label fw-semibold">Rechercher patient</label>
          <input v-model="searchQuery" class="form-control" placeholder="Nom, prénom..." />
        </div>

        <div class="col-6 col-md-2">
          <label class="form-label fw-semibold">Date début</label>
          <input type="date" v-model="dateDebut" class="form-control" />
        </div>

        <div class="col-6 col-md-2">
          <label class="form-label fw-semibold">Date fin</label>
          <input type="date" v-model="dateFin" class="form-control" />
        </div>

        <div class="col-12 col-md-3">
          <label class="form-label fw-semibold">Assurance</label>
          <select v-model="assuranceFilter" class="form-select">
            <option value="">Toutes les assurances</option>
            <option v-for="a in assurances" :key="a.id" :value="a.nom">{{ a.nom }}</option>
          </select>
        </div>

        <div class="col-6 col-md-2">
          <label class="form-label fw-semibold">Items / page</label>
          <select v-model="itemsperpage" class="form-select">
            <option v-for="item in itemsPerPageT" :key="item" :value="item">
              {{ item }}
            </option>
          </select>
        </div>

      </div>
    </div>

    <!-- Loader -->
    <div v-if="isLoading" class="text-center my-5">
      <div class="spinner-border text-primary"></div>
      <p>Chargement...</p>
    </div>

    <!-- Tableau -->
    <div v-else class="card shadow-sm rounded">

      <div class="row m-3 g-3">

 <div class="col-md-4">
  <div class="fw-bold total-box text-center">
    Total Patient :
    <span class="text-success d-block fs-5">
      {{ totalPatient.toLocaleString() }} FCFA
    </span>
  </div>
</div>

  <div class="col-md-4">
  <div class="fw-bold total-box text-center">
    Total Assurance :
    <span class="text-primary d-block fs-5">
      {{ totalAssurance.toLocaleString() }} FCFA
    </span>
  </div>
</div>
  <div class="col-md-4">
  <div class="fw-bold total-box text-center">
    Total :
    <span class="text-success d-block fs-5">
      {{ totalGeneral.toLocaleString() }} FCFA
    </span>
  </div>
</div>

</div>


      <div class="table-responsive overflow-auto">
        <table class="table table-bordered table-hover align-middle text-center">

          <thead class="table-primary">
            <tr>
              <th>#</th>
              <th>Date</th>
              <th>Patient</th>
              <th>Consultation</th>
              <th>Montant Consult</th>
              <th>Assurance</th>
              <th>Taux couverture</th>
              <th>Numéro Assurance</th>
              <th>Part Assurance</th>
              <th>Part Patient</th>
               <!--<th>Reste</th>-->
              <th>Statut paiement</th>
              <th>Consultation payée</th>
              <th>Enregistré par</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(p, index) in paiementsAvecCalcul" :key="p.id">
              <td>{{ index + 1 }}</td>
              <td>{{ formatDate(p.createdAt) }}</td>
              <td>{{ p.patientNom }} {{ p.patientPrenom }}</td>
              <td>{{ p.typeConsultationNom }}</td>

              <td>{{ p.montantConsultation?.toLocaleString() }}</td>
              <td>
  {{ p.assuranceNom || '—' }}
</td>

<td>
  <span 
    v-if="p.contratTauxCouverture"
    class="badge bg-info"
  >
    {{ p.contratTauxCouverture }} %
  </span>

  <span v-else>
    —
  </span>
</td>

<td>
  {{ p.numeroAssurance || '—' }}
</td>
              <!-- ✅ PART ASSURANCE = RESTE -->
              <td class="text-primary fw-bold">
                {{ p.partAssurance.toLocaleString() }}
              </td>

              <!--  PART PATIENT = MONTANT PAYÉ -->
              <td class="text-success fw-bold">
                {{ p.partPatient.toLocaleString() }}
              </td>

              <!-- RESTE 
              <td class="fw-bold text-danger">
                {{ p.reste.toLocaleString() }}
              </td>-->

              <!-- Statut du paiement (Payé / Annulé) -->
              <td>
                <span
                  class="badge"
                  :class="p.statut === 'Annulé' ? 'bg-danger' : 'bg-success'"
                >
                  {{ p.statut || '—' }}
                </span>
              </td>

              <!-- Statut estPaye de la consultation liée -->
              <td>
                <span
                  class="badge"
                  :class="p.consultationEstPaye === 'Payé' ? 'bg-success' : 'bg-warning text-dark'"
                >
                  {{ p.consultationEstPaye || '—' }}
                </span>
              </td>

              <td>{{ p.createdByNom }} {{ p.createdByPrenom }}</td>
            </tr>

            <tr v-if="paiements.length === 0">
              <td colspan="12">Aucune donnée trouvée</td>
            </tr>
          </tbody>

        </table>
      </div>

    </div>
  </div>
</template>

<script>
import api from "@/api";
import dayjs from "dayjs";

export default {
  data() {
    return {
      isLoading: true,
      isFirstLoad: true,
      searchQuery: '',
      dateDebut: dayjs().format("YYYY-MM-DD"),
      dateFin: '',
      assuranceFilter: '',
      paiements: [],
      totalItems: 0,
      currentPage: 1,
      itemsperpage: 30,
      itemsPerPageT: [30, 60, 90],
      sortOrder: 'desc',
      assurances: [],
       systeme: null,
      configClinique: {}
    };
  },

 computed: {
  totalAssurance() {
    return this.paiementsAvecCalcul
      .filter(p => p.statut !== 'Annulé')
      .reduce((t, p) => t + p.partAssurance, 0);
  },

  //  TOTAL DE CE QUE LES PATIENTS ONT PAYÉ
  totalPatient() {
    return this.paiementsAvecCalcul
      .filter(p => p.statut !== 'Annulé')
      .reduce((total, p) => total + p.partPatient, 0);
  },

  totalGeneral() {
    return this.totalPatient + this.totalAssurance;
  },

  filteredPaiements() {
    let list = this.paiements;

    if (this.searchQuery) {
      const q = this.searchQuery.toLowerCase();
      list = list.filter(p =>
        `${p.patientNom} ${p.patientPrenom}`.toLowerCase().includes(q)
      );
    }

    if (this.assuranceFilter) {
      list = list.filter(p => p.assuranceNom === this.assuranceFilter);
    }

    if (this.dateDebut) {
      const debut = new Date(this.dateDebut);
      list = list.filter(p => new Date(p.createdAt) >= debut);
    }

    if (this.dateFin) {
      const fin = new Date(this.dateFin);
      fin.setHours(23, 59, 59, 999);
      list = list.filter(p => new Date(p.createdAt) <= fin);
    }

    return list;
  },

  //  CALCUL FINAL — reste inchangé, garde TOUTES les lignes
  //  (y compris annulées) pour que le tableau les affiche toujours
  paiementsAvecCalcul() {
    return this.filteredPaiements.map(p => {

      const montantConsultation = Number(
        p.montantConsultation || 0
      );

      const partPatient = Number(
        p.montant || 0
      );

      const taux = Number(
        p.contratTauxCouverture || 0
      );

      const partAssurance =
        (montantConsultation * taux) / 100;

      const reste = Math.max(
        montantConsultation - partPatient - partAssurance,
        0
      );

      return {
        ...p,
        partPatient,
        partAssurance,
        reste
      };
    });
  }
},
  methods: {

    formatDate(date) {
      return dayjs(date).format("DD-MM-YYYY HH:mm");
    },

    async getPaiements() {
      try {
        this.isLoading = true;
        const res = await api.getItems("paiement_consultations");
        this.paiements = res.data.data;
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
      }
    },

    async getAssurances() {
      const res = await api.getItems("assurances");
      this.assurances = res.data.data;
    },
  async getConfigurationSysteme() {
      try {
        const res = await api.getItems('configurations');
        this.systeme = res.data.data[0];
        const baseUrl = process.env.VUE_APP_API_BASE_URL || '';
        if (this.systeme.logo) this.systeme.logoUrl = baseUrl + this.systeme.logo;
      } catch (e) {
        console.error('Erreur chargement configuration système', e);
      }
    },
   
imprimerPaiements() {

  const config = this.systeme || {};
  const paiements = this.paiementsAvecCalcul;

  if (!paiements.length) {
    alert("Aucune donnée à imprimer !");
    return;
  }

  const totalPatient = this.montantTotal;
  const totalAssurance = this.totalAssurance;

  const dateDebut = this.dateDebut
    ? this.formatDate(this.dateDebut)
    : "—";

  const dateFin = this.dateFin
    ? this.formatDate(this.dateFin)
    : "—";

  const rowsHtml = paiements.map((p, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${this.formatDate(p.createdAt)}</td>
      <td>${p.patientNom} ${p.patientPrenom}</td>
      <td>${p.typeConsultationNom || ""}</td>
      <td>${Number(p.montantConsultation || 0).toLocaleString()}</td>
      <td>
  <div class="fw-bold">
    {{ p.assuranceNom || '—' }}
  </div>

  <span 
    v-if="p.contratTauxCouverture"
    class="badge bg-info mt-1"
  >
    {{ p.contratTauxCouverture }} %
  </span>
</td>
      <td class="assurance">${Number(p.partAssurance || 0).toLocaleString()}</td>
      <td class="patient">${Number(p.partPatient || 0).toLocaleString()}</td>
      <td class="reste">${Number(p.reste || 0).toLocaleString()}</td>
      <td>${p.createdByNom || ""} ${p.createdByPrenom || ""}</td>
    </tr>
  `).join("");

  const htmlContent = `
  <html>
  <head>
    <title>Impression Paiements Consultation</title>

    <style>
      @page {
        size: A4;
        margin: 2.5cm;
      }

      body {
        font-family: Arial, sans-serif;
        font-size: 13px;
        color: #333;
      }

      h2 {
        text-align: center;
        color: #0d6efd;
        margin-bottom: 5px;
      }

      .periode {
        text-align: center;
        font-size: 14px;
        margin-bottom: 15px;
        font-weight: bold;
      }

      table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 10px;
      }

      th, td {
        border: 1px solid #ccc;
        padding: 6px;
        text-align: center;
      }

      th {
        background: #e9f2ff;
        font-weight: bold;
      }

      .patient { color: #198754; font-weight: bold; }
      .assurance { color: #0d6efd; font-weight: bold; }
      .reste { color: #dc3545; font-weight: bold; }

      .totaux {
        margin-top: 25px;
        display: flex;
        justify-content: space-between;
        font-size: 15px;
        font-weight: bold;
      }

      .box {
        border: 2px solid #0d6efd;
        padding: 10px 15px;
        border-radius: 6px;
        width: 48%;
        text-align: center;
      }

      footer {
        margin-top: 30px;
        text-align: center;
        font-size: 12px;
        border-top: 1px solid #ccc;
        padding-top: 8px;
      }
    </style>
  </head>

  <body>

    <h2>LISTE DES PAIEMENTS CONSULTATION</h2>

    <div class="periode">
      Période : du ${dateDebut} au ${dateFin}
    </div>

    <table>
      <thead>
        <tr>
          <th>#</th>
          <th>Date</th>
          <th>Patient</th>
          <th>Consultation</th>
          <th>Montant</th>
          <th>Assurance</th>
          <th>Part Assurance</th>
          <th>Part Patient</th>
          <th>Reste</th>
          <th>Enregistré par</th>
        </tr>
      </thead>
      <tbody>
        ${rowsHtml}
      </tbody>
    </table>

    <div class="totaux">
      <div class="box">
        TOTAL PATIENT <br>
        <span style="color:#198754">
          ${totalPatient.toLocaleString()} FCFA
        </span>
      </div>

      <div class="box">
        TOTAL ASSURANCE <br>
        <span style="color:#0d6efd">
          ${totalAssurance.toLocaleString()} FCFA
        </span>
      </div>
    </div>

    <footer>
      <p>Impression effectuée le ${new Date().toLocaleString()}</p>
    </footer>

  </body>
  </html>
  `;

  const printWindow = window.open("", "_blank");
  printWindow.document.write(htmlContent);
  printWindow.document.close();

  printWindow.onload = () => {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
},
exportCsv() {

  const rows = this.paiementsAvecCalcul;

  if (!rows.length) {
    alert("Aucune donnée à exporter !");
    return;
  }


  const dateDebut = this.dateDebut
    ? dayjs(this.dateDebut).format("DD-MM-YYYY")
    : "—";


  const dateFin = this.dateFin
    ? dayjs(this.dateFin).format("DD-MM-YYYY")
    : "—";


  const headers = [
    "Date",
    "Patient",
    "Consultation",
    "Montant Consultation",
    "Assurance",
    "Taux Couverture",
    "Numéro Assurance",
    "Part Assurance",
    "Part Patient",
    "Reste Patient",
    "Enregistré par"
  ];


  const data = rows.map(p => [

    this.formatDate(p.createdAt),

    `${p.patientNom || ""} ${p.patientPrenom || ""}`,

    p.typeConsultationNom || "",

    Number(
      p.montantConsultation || 0
    ),

    p.assuranceNom || "—",

    p.contratTauxCouverture
      ? `${p.contratTauxCouverture}%`
      : "—",

    p.contratNumeroAssure || "—",


    Number(
      p.partAssurance || 0
    ),


    Number(
      p.partPatient || 0
    ),


    Number(
      p.reste || 0
    ),


    `${p.createdByNom || ""} ${p.createdByPrenom || ""}`

  ]);



  const totalPatient = this.totalPatient || 0;

  const totalAssurance = this.totalAssurance || 0;

  const totalGlobal = this.totalGeneral || 0;



  const csv =
    "\uFEFF" +

    "LISTE DES PAIEMENTS CONSULTATION\n" +

    `Période;Du ${dateDebut};Au ${dateFin}\n\n` +

    headers.join(";") +
    "\n" +

    data.map(row => row.join(";")).join("\n") +


    "\n\nRÉCAPITULATIF\n" +

    `Total Patient;${totalPatient}\n` +

    `Total Assurance;${totalAssurance}\n` +

    `Total Global;${totalGlobal}\n`;



  const blob = new Blob(
    [csv],
    {
      type: "text/csv;charset=utf-8;"
    }
  );


  const url = URL.createObjectURL(blob);


  const link = document.createElement("a");

  link.href = url;

  link.download =
    `paiements_consultation_${dateDebut}_${dateFin}.csv`;


  link.click();


  URL.revokeObjectURL(url);

}




  },

  created() {
    this.getPaiements();
    this.getAssurances();
    this.getConfigurationSysteme();
  }
};
</script>

<style>
.total-box {
  font-size: 16px;
  font-weight: bold;
  padding: 10px;
  border: 2px solid #198754;
  border-radius: 6px;
  background: #eefaf1;
}
</style>
